module.exports = __webpack_public_path__ + "img/loading.1e846449.gif";